import { useLocation } from 'react-router-dom'
import rootHistory from '../../rootHistory'
import { useUserReduxParse } from './useUserReduxParse'

//parse user 가 변했을시 redux 도 따라 변하게 함
export const useUserWithRedirect = () => {
  const location = useLocation()
  const reduxUser = useUserReduxParse()
  if (reduxUser) {
    return reduxUser
  } else {
    rootHistory.push({
      pathname: '/login',
      state: { from: location.pathname },
    })
  }
}
